import React,{ useEffect, useState } from 'react';
import { Box, TextField, Button, Checkbox, FormControlLabel, Typography, MenuItem, Grid,Select,FormControl,InputLabel,Modal, Autocomplete  } from '@mui/material';
import { signUpSuccess } from "../../redux/userReducer";
import graphqlRequest from "../../requestMethod";
import EmailOtp from "../../components/PopUp/Otp/EmailOtp/EmailOtp";
import PhoneOtp from "../../components/PopUp/Otp/PhoneOtp/PhoneOtp";
import { clearState } from "../../redux/apiCall";
import { message } from "../../components/Common/SnakeAlert/SnakeAlert";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { pushEvent, pushProfile } from '../../utils/clevertap';
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const RegistrationForm = ({ onClose }) => {
    const [emailOtpField, setEmailOtpField] = useState(new Array(4).fill(""));
  const [phoneOtpField, setPhoneOtpField] = useState(new Array(4).fill(""));
  const [modalForEmailOtp, setModalForEmailOtp] = useState(false);
  const [modalForPhoneOtp, setModalForPhoneOtp] = useState(false);
  const [isEmailVerifyed, setIsEmailVerifyed] = useState(false);
  const [isPhoneVerifyed, setIsPhoneVerifyed] = useState(false);
  const [emailToken, setEmailToken] = useState("");
  const [phoneToken, setPhoneToken] = useState("");
  const [cityList, setCityList] = useState([]);
  const [customCity, setCustomCity] = useState("");


  const [isDidsabled, setIsDisabled] = useState(false);

  let [companyTypeList, setCompanyTypeList] = useState([]);
  let [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedCompanyType, setSelectedCompanyType] =
    useState("");

  let [term, setTerm] = useState(false);
  let [formError, setFormError] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const UserDetails = useSelector((state) => state?.user?.signUpUserGmail);
  console.log("USER DETAILS", UserDetails);

  let [userRegistration, setUserRegistration] = useState({
    salutation: "",
    organization: "",
    role: "",
    companyType: "",
    website: "",
    name: UserDetails?.name,
    email: UserDetails?.email,
    phone: "",
    employerCity: ""
  });

  const [selectedCity, setSelectedCity] = useState(userRegistration.employerCity || "");



  function fetchComapnyListData() {
    const query = `

 query{

 listCompanyType{

name,

 id
 }

}

`;

    graphqlRequest(query).then((response) => {
      console.log("Company List", response?.data?.listCompanyType);

      let sortedCompanies = response?.data?.listCompanyType.sort(function (
        a,

        b
      ) {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase

        const nameB = b.name.toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        } // names must be equal

        return 0;
      });

      console.log("Company List Sorted", sortedCompanies);

      setCompanyTypeList(sortedCompanies);
    });
  }
  function verifyEmail() {
    const query = `
      mutation {
      verifyEmail(email:"${userRegistration?.email}")
      }
    `;
    graphqlRequest(query).then((response) => {
      if (response?.errors) {
        message.error(response.errors[0].message);
      } else {
        setModalForEmailOtp(true);
        setEmailToken(response.data.verifyEmail);
        message.success("OTP has been sent.");
      }
    });
  }
  function verifyPhone() {
    const query = `
    mutation {
      verifyPhone(contact:{code:"91",mobile:"${userRegistration?.phone}"})
    }
  `;
    graphqlRequest(query).then((response) => {
      if (response?.errors) {
        message.error("Phone number already exists!");
      } else {
        setModalForPhoneOtp(true);
        setPhoneToken(response.data.verifyPhone);
        message.success("Otp sent Successfully!");
      }
    });
  }

  useEffect(() => {
    fetchComapnyListData();
    setEmailOtpField();
  }, []);

  const salutationList = [
    {
      id: 1,
      name: "Mr",
    },
    {
      id: 2,
      name: "Mrs",
    },
    {
      id: 3,
      name: "Ms",
    },
    {
      id: 4,
      name: "Dr",
    },
  ];

  console.log("salutationList", salutationList)
  function handleUserInput(property, value) {
    setUserRegistration({ ...userRegistration, [property]: value });
    console.log("USER REGISTRATION", userRegistration);
  }
  function validateForm() {
    let error = {};
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!userRegistration.name) {
      error.name = "Name is Required";
    }
    // if(!/^[A-Za-z]{2,}$/.test(userRegistration.name)){ 
    //   error.name = "Name should contain at least two alphabets.";-
    // }
    if (
      userRegistration?.name?.length < 3 ||
      userRegistration?.name?.length > 30
    ) {
      error.name =
        "Your name must be greater than 2 char and less than 30 char";
    }
    if (!userRegistration.phone) {
      error.phone = "Phone Number is Required";
    }
    if (userRegistration?.phone?.length !== 10) {
      error.phone = "Phone Number invalid ";
    }
    if (!userRegistration.companyType) {
      error.companyType = "Company Type is required";
    }
    if (!userRegistration.email) {
      error.email = "Email is Required";
    }
    if (!regex.test(userRegistration.email)) {
      error.email = "Please enter valid Email.";
    }
    if (!userRegistration.role) {
      error.role = "Role is required";
    }
    if (
      userRegistration?.role?.length < 2 ||
      userRegistration?.role?.length > 30
    ) {
      error.role = "Role is required";
    }
    if (!userRegistration.salutation) {
      error.salutation = "Salutation is required";
    }
    if (!userRegistration.organization) {
      error.organization = "Registered Company Name is required";
    }
    if (!term) {
      error.term = "Terms and condition needs to be checked";
    }

    if (!isEmailVerifyed) {
      error.emailVerified = "Email Not Verified";
      // message.error("Email Not Verified");
    }

    if (!isPhoneVerifyed) {
      error.isPhoneVerified = "Phone Number not Verified";
      // message.error("Phone Number not Verified");
    }

    if (!userRegistration.employerCity) {
      error.employerCity = "City is required";
    }

    return error;
  }

  const handleSubmit = (e) => {
    console.log("inside here")
    navigate('/home');
    e.preventDefault();
    handleRegistrationInput();
  };
    
  function handleRegistrationInput() {
    const query = `
   mutation{
       signupHospital(salutation:${userRegistration?.salutation}, name:"${userRegistration?.name}",organization:"${userRegistration?.organization}",email:"${userRegistration?.email}",contact:{code:"91",mobile:"${userRegistration.phone}"},role:"${userRegistration.role}",companyType:"${userRegistration.companyType}",employerCity:"${userRegistration?.employerCity}",website:"${userRegistration.website}")
     }
  `;
    graphqlRequest(query).then((response) => {
      console.log("SIGN UP RESPONSE", response);
      // window.dataLayer.push({
      //   event: "sign_up: signup_completed_successfuly",
      // });
      // message.success(
      //   "Thanks for Registering. Email has been sent to you for next steps."
      // );

      console.log(window.dataLayer);
      // console.log("123-->", response);
      const msg = clearState(dispatch);
      if (response?.errors) {
        message.error("Some Issue With SignUp");
      } else {
        // navigate("/login");
        // navigate("/home");
        // trackUserRegistration();

        window.dataLayer.push({
          event: "sign_up: signup_completed_successfuly",
        });
        message.success(
          "Thank you for Registering. Email has been sent to you for next steps."
        );
        // pushEvent("Web_SignUp_Success", {
        //   page: "Sign Up",
        //   section: "Login",
        // });
        dispatch(signUpSuccess());
        navigate("/home");

      }
    });
  }
  useEffect(() => {
    setFormError(validateForm());
  }, [term, userRegistration, isEmailVerifyed, isPhoneVerifyed]);

 
 
  useEffect(() => {
    fetch("/city_list.xlsx") // Ensure the file is in the `public` folder
      .then((response) => response.arrayBuffer())
      .then((data) => {
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // Read first sheet
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet);
        const extractedCities = jsonData.map((row, index) => ({
          id: index + 1, 
          name: row.Cities,
        }));

        // console.log("extractedCities", extractedCities)

        setCityList(extractedCities);
      })
      .catch((error) => console.error("Error loading city file:", error));
  }, []);

  let cityOptions = [...cityList, { name: "Others" }];


  console.log("cityList", cityList)

  return (
   
    <Box
    sx={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 16,
      padding: 2,
    }}
  >
    <Box
      component="form"
      noValidate
      autoComplete="off"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: {
          xs: "100%",
          sm: "90%",
          md: "650px"
        },
        maxHeight: "90vh",
        overflowY: "auto",
        // maxWidth: '350px',
        padding: '15px',
        backgroundColor: '#fff',
        p: { xs: 3, md: 4 },
        borderRadius: '20px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.91)',
      }}
      // className="signup-form"
    >

<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 0
  }}
>
  <Typography
    sx={{
      fontSize: "18px",
      fontWeight: 600,
      color: "#1f2937"
    }}
  >
    Take your healthcare hiring to the next level
  </Typography>
<IconButton
  onClick={onClose}
  sx={{
    cursor: "pointer" ,
    border: "1px solid #e5e7eb",
    "&:hover": { background: "#e5e7eb" }
  }}
>
  <CloseIcon fontSize="small" />
</IconButton>
  
</Box>
{/* <IconButton
  onClick={onClose}
  sx={{
    right:0,
    marginRight:2,
    position: "absolute",
    background: "#f3f4f6",
    border: "1px solid #e5e7eb",
    "&:hover": { background: "#e5e7eb" }
  }}
>
  <CloseIcon fontSize="small" />
</IconButton> */}
<Grid container spacing={2}> {/* Grid container for form fields */}
     
<Grid item xs={4} sm={2}>
          <FormControl fullWidth required>
          <Typography className="label">Salutation</Typography>
          <Select
  labelId="salutation-label"
  id="salutation"
  value={userRegistration.salutation}
  onChange={(e) => handleUserInput("salutation", e.target.value)}
  size="small"
  fullWidth
  sx={{
    height: "40px",
    "& .MuiOutlinedInput-root": {
      height: "40px",
      borderRadius: "8px"
    },
    "& .MuiSelect-select": {
      padding: "8.5px 14px",
      display: "flex",
      alignItems: "center"
    }
  }}
>
        {salutationList.map((item) => (
          <MenuItem key={item.id} value={item.name}>{item.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
          </Grid>
          <Grid item xs={8} sm={10}>
          <Typography className="label">Full Name <span style={{color: '#ef4444'}}>*</span></Typography>
          <TextField
                            required
                            name="name"
                            autoComplete="off"
                            defaultValue={UserDetails?.name}
                            size="small"
                            fullWidth
                            onBlur={() => {
                              if (formError.name) {
                                message.error(formError.name);
                              }
                            }}
                            onChange={(e) =>
                              handleUserInput("name", e.target.value)
                            }
                            variant="outlined"
                            renderValue={(selected) => {
                              if (!selected) return "";
                              else return selected;
                            }}
                            sx={{
                              height: "40px",
                              "& .MuiOutlinedInput-root": {
                                height: "40px",
                                // borderRadius: "8px"
                              },
                              "& .MuiInputBase-input": {
                                // height: "30px",
                                padding: "8.5px 14px",
                                border:'none',
                                display: "flex",
                                alignItems: "center"
                              }
                            }}
                            
                          />
          </Grid>
          <Grid item xs={12}>
  <Typography className="label">Official Email ID <span style={{color: '#ef4444'}}>*</span></Typography>

  <Box
    sx={{
      display: "flex",
      gap: 1,
      alignItems: "center"
    }}
  >
    <TextField
      required
      name="official_email"
      autoComplete="off"
      defaultValue={UserDetails?.email}
      size="small"
      fullWidth
      variant="outlined"
      disabled={isEmailVerifyed}
      onChange={(e) => handleUserInput("email", e.target.value)}
      onBlur={() => {
        if (formError.email) {
          message.error(formError.email);
        }
      }}
      sx={{
        height: "40px",
        "& .MuiOutlinedInput-root": {
          height: "40px",
          // borderRadius: "8px"
        },
        "& .MuiInputBase-input": {
          // height: "30px",
          padding: "8.5px 14px",
          border:'none',
          display: "flex",
          alignItems: "center"
        }
      }}
    />

    <Button
      variant="outlined"
      disabled={formError?.email || isEmailVerifyed}
      onClick={verifyEmail}
       style={{
          backgroundColor: isEmailVerifyed && "green",
          color: isEmailVerifyed && "#fff",
          minWidth: "90px"
        }}
      sx={{
        // height: "40px",
        minWidth: "90px",
        flexShrink: 0,
        
      }}
    >
      {isEmailVerifyed ? "Verified" : "Verify"}
    </Button>
  </Box>
</Grid>

<Modal
                        open={modalForEmailOtp}
                        onClose={setModalForEmailOtp}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <EmailOtp
                          verifyEmail={verifyEmail}
                          openOtpHandler={modalForEmailOtp}
                          setOpenOtpHandler={setModalForEmailOtp}
                          verifyMode="Email id"
                          emailToken={emailToken}
                          setIsEmailVerifyed={setIsEmailVerifyed}
                          setModalForEmailOtp={setModalForEmailOtp}
                          isEmailVerifyed={isEmailVerifyed}
                          emailLabel={userRegistration?.email}
                          userRegistration={userRegistration}
                        />
                      </Modal>

        {/* Phone field and Verify button */}
        {/* <Grid container spacing={1} alignItems="center" sx={{ marginTop: '.4rem' }}>
          <Grid item xs={.5} /> 
          <Grid item xs={7.5}> 
            <TextField required label="Phone" fullWidth variant="outlined" size="small" />
          </Grid>
          <Grid item xs={4}>
            <Button variant="outlined" color="primary" fullWidth>Verify</Button>
          </Grid>
        </Grid> */}

<Grid item xs={12}>
  <Typography className="label">Phone Number <span style={{color: '#ef4444'}}>*</span></Typography>

  <Box
    sx={{
      display: "flex",
      gap: 1,
      alignItems: "center"
    }}
  >
    <TextField
      required
      name="phone"
      autoComplete="off"
      type="number"
      size="small"
      fullWidth
      disabled={isPhoneVerifyed}
      onChange={(e) => handleUserInput("phone", e.target.value)}
      onBlur={() => {
        if (formError.phone) {
          message.error(formError.phone);
        }
      }}
      onInput={(e) => {
        e.target.value = Math.max(0, parseInt(e.target.value))
          .toString()
          .slice(0, 10);
      }}
      sx={{
        height: "40px",
        "& .MuiOutlinedInput-root": {
          height: "40px",
          // borderRadius: "8px"
        },
        "& .MuiInputBase-input": {
          // height: "30px",
          padding: "8.5px 14px",
          border:'none',
          display: "flex",
          alignItems: "center"
        }
      }}
    />

    <Button
      variant="outlined"
      disabled={formError?.phone || isPhoneVerifyed}
      onClick={verifyPhone}
       style={{
          backgroundColor: isPhoneVerifyed && "green",
          color: isPhoneVerifyed && "#fff",
          minWidth: "90px", 
        }}
      sx={{
        // height: "40px",
        minWidth: "90px",
        flexShrink: 0,
      }}
    >
      {isPhoneVerifyed ? "Verified" : "Verify"}
    </Button>
  </Box>
</Grid>


<Modal
  open={modalForPhoneOtp}
  onClose={setModalForPhoneOtp}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Grid container justifyContent="center" alignItems="center">
    <Grid item>
      <PhoneOtp
        verifyPhone={verifyPhone}
        openOtpHandler={modalForPhoneOtp}
        setOpenOtpHandler={setModalForPhoneOtp}
        verifyMode="Phone Number"
        otpField={phoneOtpField}
        setOtpField={setPhoneOtpField}
        phoneToken={phoneToken}
        setModalForPhoneOtp={setModalForPhoneOtp}
        setIsPhoneVerifyed={setIsPhoneVerifyed}
        phoneLabel={userRegistration?.phone}
        userRegistration={userRegistration}
      />
    </Grid>
  </Grid>
</Modal>


        {/* <Grid item xs={12}>
          <TextField required label="Company Type" fullWidth select variant="outlined" size="small">
            <MenuItem value="Type 1">Type 1</MenuItem>
            <MenuItem value="Type 2">Type 2</MenuItem>
            <MenuItem value="Type 3">Type 3</MenuItem>
          </TextField>
        </Grid> */}

<Grid item xs={12}> {/* Company Type field */}
  <FormControl fullWidth required>
  <Typography className="label">Type of Company <span style={{color: '#ef4444'}}>*</span></Typography>

    <Select 
      variant="outlined" 
      size="small"
      labelId="demo-simple-select-autowidth-label"
      id="demo-simple-select-autowidth"
      value={selectedCompanyType}
      onChange={(e) => {
        const selectedValue = e.target.value;
        setSelectedCompanyType(selectedValue);
        let data = companyTypeList?.filter((data) => {
          return data.name === selectedValue;
        });
        handleUserInput("companyType", data[0].id);
      }}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) return "";
        else return selected;
      }}
      inputProps={{ 'aria-label': 'Without label' }}
    >
      <MenuItem disabled value="">
        Type of company<span style={{color: '#ef4444'}}>*</span>
      </MenuItem>
      {companyTypeList?.map((data) => (
        <MenuItem key={data?.id} value={data?.name}>
          {data?.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


<Grid item xs={12} sm={6}> {/* Company Name field */}
          {/* <TextField required label="Company Name" fullWidth variant="outlined" size="small" /> */}
          <Typography className="label">Registered Company<span style={{color: '#ef4444'}}>*</span></Typography>
          <TextField
                      required
                      name="registered_org"
                      autoComplete="off"
                      fullWidth
                      variant="outlined" 
                      size="small"
                      onBlur={() => {
                        if (formError.organization) {
                          message.error(formError.organization);
                        }
                      }}
                      onChange={(e) =>
                        handleUserInput("organization", e.target.value)
                      }
                      displayEmpty
                     
                      renderValue={(selected) => {
                        if (!selected) return "";
                        else return selected;
                      }}
                      sx={{
                        height: "40px",
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                          // borderRadius: "8px"
                        },
                        "& .MuiInputBase-input": {
                          // height: "30px",
                          padding: "8.5px 14px",
                          border:'none',
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                    />
        </Grid>
        <Grid item xs={12} sm={6}>{/* Role field */}
        <Typography className="label">Role <span style={{color: '#ef4444'}}>*</span></Typography>
          {/* <TextField required label="Role" fullWidth variant="outlined" size="small" /> */}
          <TextField
                     required
                      name="role"
                      // label="Your Role*"
                      autoComplete="off"
                      fullWidth
                      variant="outlined" 
                      size="small"
                      sx={{
                        height: "40px",
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                          // borderRadius: "8px"
                        },
                        "& .MuiInputBase-input": {
                          // height: "30px",
                          padding: "8.5px 14px",
                          border:'none',
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                      onBlur={() => {
                        if (formError.role) {
                          message.error(formError.role);
                        }
                      }}
                      onChange={(e) => handleUserInput("role", e.target.value)}
                      
                    />
        </Grid>

{/* city */}
{/* <Grid item xs={12}>
      <FormControl fullWidth required>
        <Autocomplete
          options={cityList}
          getOptionLabel={(option) => option.name} // Extract city name
          value={cityList.find((city) => city.name === selectedCity) || null}
          onChange={(event, newValue) => {
            setSelectedCity(newValue?.name || "");
            handleUserInput("employerCity", newValue?.name || "");
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select City*" variant="outlined" size="small" />
          )}
        />
      </FormControl>
    </Grid> */}

<Grid item xs={12} sm={6}>
      <FormControl fullWidth required>
      <Typography className="label">Select City <span style={{color: '#ef4444'}}>*</span></Typography>
      <Select
  value={selectedCity || ""}
  onChange={(event) => {
    const value = event.target.value;

    if (value === "Others") {
      setSelectedCity("Others");
      handleUserInput("employerCity", customCity);
    } else {
      setSelectedCity(value);
      handleUserInput("employerCity", value);
    }
  }}
  size="small"
  fullWidth
  sx={{
    height: "40px",
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px"
    }
  }}
>
  {cityOptions.map((item) => (
    <MenuItem key={item.id} value={item.name}>
      {item.name}
    </MenuItem>
  ))}
</Select>
        {/* <Autocomplete
          options={cityOptions}
          getOptionLabel={(option) => option.name}
          value={cityOptions.find((city) => city.name === selectedCity) || null}
          onBlur={() => {
            if (formError.name) {
              message.error(formError.name);
            }
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              paddingRight: "10px"
            },
            "& fieldset": {
              // border: "1px solid #c4c4c4"
            }
          }}
          onChange={(event, newValue) => {
            if (newValue?.name === "Others") {
              setSelectedCity("Others");
              handleUserInput("employerCity", customCity);
            } else {
              setSelectedCity(newValue?.name || "");
              handleUserInput("employerCity", newValue?.name || "");
            }
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" 
           
            />
          )}
        /> */}
      </FormControl>

      {/* Show input field if "Others" is selected */}
      {selectedCity === "Others" && (
        <TextField
          required
          fullWidth
          variant="outlined"
          size="small"
          label="Enter City Name"
          value={customCity}
          onBlur={() => {
            if (formError.name) {
              message.error(formError.name);
            }
          }}
          onChange={(e) => {
            setCustomCity(e.target.value);
            handleUserInput("employerCity", e.target.value);
          }}
          style={{ marginTop: "10px" }}
          sx={{
            height: "40px",
            "& .MuiOutlinedInput-root": {
              height: "40px",
              // borderRadius: "8px"
            },
            "& .MuiInputBase-input": {
              // height: "30px",
              padding: "8.5px 14px",
              border:'none',
              display: "flex",
              alignItems: "center"
            }
          }}
        />
      )}
    </Grid>

    <Grid item xs={12} sm={6}> {/* Website field */}
        <Typography className="label">
           Website <span className="optional">(Optional)</span>
         </Typography>
          {/* <TextField label="Website (optional)" fullWidth variant="outlined" size="small" /> */}
          <TextField
                      name="website"
                      autoComplete="off"
                      fullWidth
                      variant="outlined" 
                      size="small"
                      onChange={(e) =>
                        handleUserInput("website", e.target.value)
                      }
                      sx={{
                        height: "40px",
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                          // borderRadius: "8px"
                        },
                        "& .MuiInputBase-input": {
                          // height: "30px",
                          padding: "8.5px 14px",
                          border:'none',
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                    
                    />
        </Grid>
        {/* <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            control={<Checkbox />}
            label={(
              <>
                <Typography variant="body2">
                  I agree to these <a href="#" style={{ color: '#1976d2', textDecoration: 'none' }}>Terms and Conditions</a>  <span style={{ fontSize: '1rem', marginLeft: '4px' }}>*</span>
                </Typography>
              </>
            )}
          />
        </Grid> */}

<Grid item  sx={{ display: 'flex', alignItems: 'center' }}>
  <FormControlLabel
    control={
      <Checkbox
        id="vehicle2"
        name="term"
        checked={term}
        onClick={(e) => setTerm(!term)}
      />
    }
    label={
      <Typography variant="body2">
        I agree to these{' '}
        <a
          href="https://jobizo.com/terms-and-conditions/"
          style={{ color: '#2D5FA1', textDecoration: 'none' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
        <span style={{ fontSize: '1rem', marginLeft: '4px' ,color: '#ef4444' }}>*</span>
      </Typography>
    }
  />
</Grid>

        {/* <Grid item xs={12}>
          <Button
            type="submit"
            onClick={handleRegistrationInput}
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '8px',
              borderRadius: '4px',
              textTransform: 'none',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            Register with hospital
          </Button>
        </Grid> */}
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}> {/* Submit button */}
  <Button
  type="submit"
  method="POST"
    // onClick={handleRegistrationInput}
    onClick={(e) => {
     pushProfile({
             name: userRegistration?.name,
             email: userRegistration?.email,
             phone: "91"+userRegistration?.phone,
             company: userRegistration?.organization,
             role:  userRegistration.role
           });
      pushEvent("Web_SignUp_Success", {
        page: "Sign Up",
        section: "Login",
        salutation:userRegistration?.salutation,
         CompanyName:userRegistration?.organization,
         role:userRegistration.role,
         companyType:userRegistration.companyType,
         website:userRegistration?.website,
         name:userRegistration?.name,
         phone:"+91"+userRegistration?.phone,
         email:userRegistration?.email,
         city: userRegistration?.employerCity
      });
      // e.preventDefault()
      handleRegistrationInput()
    }
    }
    variant="contained"
    sx={{
      backgroundColor: Object.keys(formError).length !== 0 ? "#f8a0a0" : "#d62511",
      color: '#fff',
      borderRadius: '25px',
      fontWeight: 'bold',
      justifyContent: 'center',
      height: '35px',
      px: 4,
      '&:hover': {
        backgroundColor: Object.keys(formError).length !== 0 ? "#f8a0a0" : "#b51b0e",
      },
    }}
    disabled={Object.keys(formError).length !== 0}
  >
   Register as Employer
  </Button>
</Grid>

      </Grid>
      </Box>
    </Box>

 
    
   
  );
}

export default RegistrationForm;
